import React from "react";

import * as S from "./styles";

export const Slide20: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Column>
          <S.Title>créditos | luisa sonza</S.Title>
          <S.Text>
            <p>
              Direção de criação: Luciano Schmitz
              <br />
              Foto: Nicole Heiniger
              <br />
              Direção de vídeo: Maurício Kessler
              <br />
              Edição de moda: Flávia Pommianosky e Davi Ramos
              <br />
              Beleza: Branca Moura
              <br />
              Produção de moda: Well Santos
              <br />
              Camareira: Jô Alcantara
              <br />
              Produção de arte e cenografia: Anderson Rodriguez
              <br />
              Contrarregra: Ronaldo Junge
              <br />
              Manicure: Thayna Dandara
              <br />
              Assistentes de beleza: Moisés Aarão e Kathê Portillo
              <br />
              Assistentes de foto: Renato Machado, Fernando Lima e Marcelo Nunes
              <br />
              Chefe de elétrica: Sérgio Bronzo
              <br />
              Primeiro assistente de câmera: Cristiano Machado
              <br />
              Operadora de câmera: Dariely Belke
              <br />
              Primeiro assistente de elétrica: Sergio Bronzo Junior
              <br />
              Segundo assistente de elétrica: Rudney Santos
              <br />
              Produção executiva: Isabela de Paula
              <br />
              Produção executiva de vídeo: Chico Soll
              <br />
              Tratamento de imagem: Thiago Auge
              <br />
              Edição: Rob & Ariel
              <br />
              Digital composer: Fernando Branco
            </p>
          </S.Text>
        </S.Column>
        <S.Column>
          <S.Title>looks do editorial:</S.Title>
          <S.Text>
            <p>
              Luísa Sonza (look 1)
              <br />
              Jaqueta de pelúcia, Rober Dognani, R$ 2.100. Body com strass,
              Atelier Robbyt Moon, R$ 650. Botas, B.Luxo, R$ 980.
            </p>

            <p>
              Luísa Sonza (look 2)
              <br />
              Bodysuit, Dario Mittmann, R$ 680. Por cima, body com strass, R$
              4.000, e botas de strass R$ 3.500, ambos Andressa Salomone.
            </p>

            <p>
              Luísa Sonza (look 3)
              <br />
              Body, Triya, preço sob consulta.
            </p>
          </S.Text>
        </S.Column>
      </S.Wrapper>
    </S.Container>
  );
};
